import { useEffect, useState, memo } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

// material-ui
import { Box, Typography } from '@mui/material';
import { Add } from '@mui/icons-material';

// project imports
import NavItem from '../MenuList/NavItem';
import ProjectNavGroup from './ProjectNavGroup';
import NewProjectDialog from './new-project-dialog';
import menuItem from 'menu-items'; // menu-items/index.js
import { useDispatch, useSelector } from 'store';

// assets
import { IconLayoutBoard } from '@tabler/icons';

import { getProjects, createProject } from 'store/slices/project';

// ==============================|| SIDEBAR MENU LIST ||============================== //

const ProjectList = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { workspaceId } = useParams();
    const { projects } = useSelector((state) => state.project);
    const { selectedWorkspace } = useSelector((state) => state.workspace);

    const [selected, setSelected] = useState(null);
    const [projectGroup, setProjectGroup] = useState([]);
    const [dialogOpen, setDialogOpen] = useState(false);

    useEffect(() => {
        setSelected(workspaceId)
        dispatch(
            getProjects({
                workspaceId: workspaceId,
            })
        );
    }, [dispatch, workspaceId]);

    const createNewProject = () => {
        setDialogOpen(true);
    };

    const handleAddNewProject = (projectname, isProjectPrivate) => {
        dispatch(
            createProject({
                workspaceId: selected,
                name: projectname,
                isPrivate: isProjectPrivate
            }, (data) => {
                setProjectGroup({
                    id: 'projects',
                    title: null,
                    type: 'group',
                    children: [
                        ...projectGroup.children,
                        {
                            id: data.id,
                            title: data.name,
                            type: 'item',
                            isOwner: data.isOwner,
                            url: `/w/${selected}/p/${data.id}`,
                            icon: null,
                        }
                    ]
                })
                navigate(`/w/${selected}/p/${data.id}`)
                setDialogOpen(false);
            })
        );
    }

    useEffect(() => {
        setProjectGroup({
            id: 'projects',
            title: null,
            type: 'group',
            children: projects.map((item) => {
                return {
                    id: item.id,
                    title: item.name,
                    type: 'item',
                    isOwner: item.isOwner,
                    url: `/w/${selected}/p/${item.id}`,
                    icon: null,
                };
            })
        })
    }, [projects]);

    return (
        <>
            <Box id="project-list">
                <Box sx={{ display: 'flex', padding: '10px 16px 10px 24px' }}>
                    <Box sx={{ display: 'flex', flex: 1 }}>
                        <IconLayoutBoard size="20" color="#2D3648" />
                        <Typography
                            sx={{
                                marginLeft: '16px',
                                fontSize: '14px',
                                fontWeight: 700,
                                fontFamily: 'Gilroy-Bold',
                                color: '#2D3648',
                                alignSelf: 'end'
                            }}
                        >
                            <FormattedMessage id="project" />
                        </Typography>
                    </Box>
                    {!selectedWorkspace?.expired && (
                        <Add sx={{ width: '20px', height: '20px', cursor: 'pointer' }} onClick={() => createNewProject()} />
                    )}
                </Box>
                <ProjectNavGroup key={projectGroup.id} item={projectGroup} />
            </Box>
            
            <NewProjectDialog
                open={dialogOpen}
                handleDialogClose={() => setDialogOpen(false)}
                handleProjectCreate={
                    (name, isPrivate) => {
                        handleAddNewProject(name, isPrivate);
                    }
                }
            />
        </>
    );
};

export default memo(ProjectList);
